import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import DashboardTop from './DashboardTop';
import DashboardBot from './DashboardBot';
import SignupModal from '../Register/SignupModal'; // adjust import
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { useLoginProvider } from '../../context/LoginContext';

const Dashboard = () => {
  const { user, isAuthenticated } = useLoginProvider();
  const [profile, setProfile] = useState(null);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const isProfileComplete = (data) =>
    data &&
    data.billingAddress &&
    data.dob &&
    data.securityQuestion &&
    data.securityAnswer;

  const fetchProfile = async () => {
    setLoading(true);
    if (!user?.uid) {
      setLoading(false);
      return;
    }
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (!userDoc.exists()) {
      setProfile(null);
      setShowSignupModal(true);
    } else {
      const data = userDoc.data();
      setProfile(data);
      setShowSignupModal(!isProfileComplete(data));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isAuthenticated && user?.uid) {
      fetchProfile();
    }
    // eslint-disable-next-line
  }, [isAuthenticated, user?.uid]);

  const handleModalClose = () => {
    setShowSignupModal(false);
    fetchProfile(); // recheck after modal closes
  };

  if (loading) return <div>Loading...</div>;
  if (showSignupModal) return <SignupModal onClose={handleModalClose} />;

  return (
    <div className="dashboard topmar">
      <DashboardTop />
      <DashboardBot />
    </div>
  );
};

export default Dashboard;
